/* eslint-disable global-require */

'use strict';

if (!module.hot || process.env.NODE_ENV === 'production') {
  module.exports = require('./index.prod');
} else {
  module.exports = require('./index.dev');
}


//////////////////
// WEBPACK FOOTER
// ./~/react-hot-loader/lib/index.js
// module id = 406
// module chunks = 0